var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          "has-return": "",
          page: _vm.page,
          "right-side-class": "col-md d-flex align-items-end mb-2"
        },
        on: { onReturn: _vm.$router.back }
      }),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("board", { staticClass: "mb-3", attrs: { details: _vm.board } }),
          _c(
            "q-tab",
            { attrs: { "active-tab": _vm.activeTab } },
            [
              _c(
                "q-tab-item",
                {
                  attrs: { tabindex: 0, title: "Terapias" },
                  on: {
                    click: function($event) {
                      return _vm.setCurrentTab(0)
                    }
                  }
                },
                [
                  _vm.academicYears?.length
                    ? _c("therapies", {
                        attrs: {
                          "academic-years": _vm.academicYears,
                          referral: _vm.info
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "q-tab-item",
                {
                  attrs: { lazy: "", tabindex: 1, title: "Evaluaciones" },
                  on: {
                    click: function($event) {
                      return _vm.setCurrentTab(1)
                    }
                  }
                },
                [
                  _c("evaluations", {
                    attrs: { "student-id": _vm.info?.studentSie }
                  })
                ],
                1
              ),
              _c(
                "q-tab-item",
                {
                  attrs: { lazy: "", tabindex: 2, title: "PEI" },
                  on: {
                    click: function($event) {
                      return _vm.setCurrentTab(2)
                    }
                  }
                },
                [
                  _c("pei-history", {
                    attrs: { "student-id": _vm.info?.studentSie }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }